var $ = require('jquery');
const d3 = require("d3");
//////////////////////// HOSPITALS TREND GRAPH //////////////

const buildHospitalGraph = function(hospitalData, dateNew, hos_monthTicks, ap_months) {
  // $('#date').empty().text(dateNew);

  const lastDayData = hospitalData[hospitalData.length - 1];

  var rawLastDate = lastDayData.Date.split("/");
  var h_current_Month = rawLastDate[0];
  var h_current_Day = rawLastDate[1];
  h_current_Month = parseInt(h_current_Month) - 1;
  var formatted_last_date = ap_months[h_current_Month] + " " + h_current_Day + ", " + rawLastDate[2];

  $('#hos_tooltip .date').empty().append(formatted_last_date);
  $('#hos_tooltip .rate').append(lastDayData.Per_Hospital_Occ_COVID + "%");
  var hos_con_Width = $("#hospitalsGraphic").width();
  var hos_con_Height = (hos_con_Width > 500) ? 350 : 220;

  var margin = {top: 20, right: 20, bottom: 30, left: 40},
     hos_width = hos_con_Width - margin.left - margin.right,
     hos_height = hos_con_Height - margin.top - margin.bottom;

      var x0 = d3.scaleBand().range([0, hos_width]);

     var y = d3.scaleLinear()
         .range([hos_height, 0]);

     var xAxis = d3.axisBottom()
         .scale(x0)
         .tickValues(hos_monthTicks)
         .tickFormat((d, i) => {
           var split_date = d.split("/");
           var year = split_date[2];
           year = year.slice(2);
           return `${split_date[0]}/${year}`;
         }
       );


     var yAxis = d3.axisLeft()
         .scale(y).ticks(5).tickFormat((d, i) => d + "%");

         xAxis.tickSizeOuter(0);


         // x1.domain(d3.keys(innerColumns2)).range([0, x0.bandwidth()]);
         y.domain([0, d3.max(hospitalData, function(d) { return d.Per_Hospital_Occ_COVID;  })]);
         x0.domain(hospitalData.map(function(d) { return d.Date; }));


     var svg_hos = d3.select("#hospitalsGraphic #hospital_graph").append("svg")
         .attr("width", hos_width + margin.left + margin.right)
         .attr("height", hos_height + margin.top + margin.bottom)
       .append("g")
         .attr("class","hos_Graphic")
         .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

         svg_hos.append("g")
             .attr("class", "x axis")
             .attr("transform", "translate(0," + (hos_height + 0) + ")")
             .call(xAxis);

         svg_hos.append("g")
             .attr("class", "y axis")
             .call(yAxis)
           .append("text")
             .attr("transform", "rotate(-90)")
             // .attr("y", 6)
             .attr("dy", ".7em")
             .style("text-anchor", "end")
             .text("");

         var valueline = d3.line()
             .x(function(d) { return x0(d.Date) })
             .y(function(d) {
               return y(d.Per_Hospital_Occ_COVID);
             });


         svg_hos.append("path")
             .data([hospitalData])
             .attr("class", "line")
             .attr("fill", "none")
             .attr("stroke", "blue")
             .attr("stroke-width", 2)
             .attr("d", valueline);

               var focusContainer = svg_hos
                 .append('g')
                 .attr("class", "focusCon");

               var guideLine = focusContainer.append("line")
                    .attr("class", "guideLine")
                    .attr("x1", hos_width)
                    .attr("y1", 0)
                    .attr("x2", hos_width)
                    .attr("y2", hos_height)
                    .attr("stroke", "#7b7b7b")
                    .attr("stroke-dasharray","4");

             //   // Create a rect on top of the svg area: this rectangle recovers mouse position
               var eventCapture = svg_hos
                 .append('rect')
                 .style("fill", "none")
                 .style("pointer-events", "all")
                 .attr('width', hos_width)
                 .attr('height', hos_height)
                 .on('mousemove', mousemove);


                 x0.invert = (function(){
                  var domain = x0.domain()
                  var range = x0.range()
                  var scale = d3.scaleQuantize().domain(range).range(domain)

                    return function(x){
                        return scale(x)
                    }
                })();

               function mousemove(e) {
                 var xy = d3.mouse(eventCapture.node());
                 var d = x0.invert(xy[0]);
                 var nx = x0(d) + (x0.bandwidth()/2);

                 guideLine.transition().duration(10).attr("x1", nx).attr("x2", nx);
                 const isDateTheSame = (element) => element.Date === d;

                 var i = hospitalData.findIndex(isDateTheSame);

                 selectedData = hospitalData[i];
                 var rawDate = selectedData.Date;

                 rawDate = rawDate.split("/");
                 var h_Month = rawDate[0];
                 var h_Day = rawDate[1];
                 h_Month = parseInt(h_Month) - 1;
                 var formatted_date = ap_months[h_Month] + " " + h_Day + ", " + rawDate[2];

                 $('#hos_tooltip .date').empty().append(formatted_date);
                 $('#hos_tooltip .rate').empty().append(selectedData.Per_Hospital_Occ_COVID + "%");

                 }
}

module.exports = buildHospitalGraph;
